import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Notification } from '../../../models/notification.model';

@Component({
  selector: 'app-notification-success',
  templateUrl: './notification-success.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationSuccessComponent {
  @Input() notification: Notification | null = null;
  @Output() dismiss = new EventEmitter<void>();

  onDismiss() {
    this.dismiss.emit();
  }
}
